/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_I18nInputs */

const en_landing_chips_i18n = /** @type {(inputs: Landing_Chips_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const zh_landing_chips_i18n = /** @type {(inputs: Landing_Chips_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国际化`)
};

/**
* | output |
* | --- |
* | "i18n" |
*
* @param {Landing_Chips_I18nInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_i18n = /** @type {((inputs?: Landing_Chips_I18nInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_I18nInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_i18n(inputs)
	return zh_landing_chips_i18n(inputs)
});
export { landing_chips_i18n as "landing.chips.i18n" }